import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { Text } from 'atoms';
import { Search, SearchBox } from './Collection.style';
import { filterSalesMen, setFilteredSalesMen, setSalesMenSearch } from 'store/salesmanSlice';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 60%;
	margin-right: 0.5rem;
`;

const SearchField = styled(Search)`
	width: 100%;
	padding: 10px;
	border: 0;
	background-color: ${(props) => props.theme.colors.Cultured};
	color: ${(props) => props.theme.colors.primary};

	::placeholder,
	::-ms-input-placeholder {
		/* Chrome, Firefox, Opera, Safari 10.1+ */
		font-size: 10px;
		font-weight: 300;
		color: ${(props) => props.theme.colors.primary};
		opacity: 1; /* Firefox */
	}
`;

export default function SalesMenSearch() {
	const [search, setSearch] = useState('');
	const { salesMen = [] } = useSelector((state) => state.salesman);
	const dispatch = useDispatch();

	console.log(salesMen);

	const handleFindSalesMen = useCallback(() => {
		if (salesMen?.length > 0 && search !== '') {
			/**
			 * Find searched word in sales Men store namd and mobile number
			 */
			const filteredData = filterSalesMen(salesMen, search);

			dispatch(setFilteredSalesMen(filteredData)); // updated sales men as filtered sales men
			dispatch(setSalesMenSearch(search)); // store searched word in redux
		}
	}, [salesMen, search, dispatch]);

	useEffect(() => {
		if (search !== '') {
			handleFindSalesMen();
		}
	}, [search, handleFindSalesMen]);

	function resetFilter() {
		/**
		 * if search input is empty clear filtered sales men with all sales men
		 */
		dispatch(setFilteredSalesMen(salesMen));
	}

	return (
		<Container>
			<Text fontSize="10px" pb="10px">
				Select Salesman Identity
			</Text>

			<SearchBox>
				<SearchField
					placeholder="Search Name or Phone Number"
					value={search}
					onChange={(e) => {
						setSearch(e.target.value);
						if (e.target.value === '') {
							/**
							 * Bring back full sales men without filter
							 */
							resetFilter();
						}
					}}
				/>
			</SearchBox>
		</Container>
	);
}
